export default function (instance) {
  return {
    getSections: (payload) => instance.post("api/sections", payload),
  };
}
